
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/club/[slug]",
      function () {
        return require("private-next-pages/club/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/club/[slug]"])
      });
    }
  